'use es6';

import { DropTarget } from 'react-dnd';
import DragTypes from 'simple-menus-core/enums/DragTypes';
import DropPositions from 'simple-menus-core/enums/DropPositions';
const target = {
  canDrop(props) {
    /* 10th item is at depth 9 */
    if (props.depth > 8) return false;
    return !props.isParentDragging;
  },
  drop(props, monitor) {
    const dragId = monitor.getItem().id;
    const {
      menuId,
      id: hoverId,
      moveNode,
      parentId
    } = props;
    if (dragId === hoverId) return;
    moveNode(dragId, hoverId, parentId, DropPositions.MIDDLE, menuId);
  }
};
export default function menuDropTarget() {
  return Component => {
    return DropTarget(DragTypes.ADVANCED_MENUS_MENU_NODE, target, (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }))(Component);
  };
}